import { Injectable } from '@angular/core';

@Injectable()
export class IframePostmessagesService {

  constructor() { }

  public sendMessage(msg: string) {
    window.top.postMessage(msg, "*");
  }
}
